import {VueRouter} from "vue-router/types/router"
import {Location} from "vue-router";

interface IQueryOptions {
  clear?: string[]
  mode?: 'push' | 'replace'
}

export const RouterHelper = {
  buildQuery(router: VueRouter, query: Location["query"] = {}, options: IQueryOptions = {}) {
    const finalQuery = Object.assign({}, router.currentRoute.query, query);
    const clear = options.clear || []
    clear.forEach(param => {
      delete finalQuery[param];
    });
    return finalQuery;
  },
  appendQuery(router: VueRouter, query: Location["query"], options: IQueryOptions = {}) {
    options.mode = options.mode || 'push'
    if (options.mode === 'replace') {
      this.replaceRouteQuery(router, this.buildQuery(router, query, options));
    } else {
      this.pushRouteQuery(router, this.buildQuery(router, query, options));
    }
  },
  pushRoute(router: VueRouter, location: Location) {
    router.push(location);
  },
  pushRouteQuery(router: VueRouter, query: Location["query"]) {
    router.push({ query: query });
  },
  replaceRouteQuery(router: VueRouter, query: Location["query"]) {
    router.replace({ query: query });
  },
  routeIs(router: VueRouter, ...names: string[]): boolean {
    return names.includes(router.currentRoute.name);
  },
  hasRouteParam(router: VueRouter, key: string, value: string): boolean {
    return router.currentRoute.query[key] === value;
  },
}
